import React from 'react';
import { Skeleton, Box } from '@landr/maestro';
import { css } from '@landr/styled-system/css';

export const PackCardSkeleton = (): JSX.Element => (
    <Box
        display="flex"
        flexDirection="column"
        data-testid="pack-card-skeleton-wrapper"
    >
        <Skeleton
            height="100%"
            width="auto"
            className={css({
                _before: {
                    content: ' ',
                    position: 'relative',
                    display: 'block',
                    paddingBottom: '100%',
                },
            })}
        />
        <Skeleton height="18px" width="70%" mt="sm" />
    </Box>
);
